"use client";
import { jsx } from "react/jsx-runtime";
import { useProductTileConfig } from "../../../../utils/ProductTileConfigProvider/ProductTileConfigProviderClient.js";
import { isBD } from "../../../../utils/businessType.lib.js";
import { useCriteo } from "../../../../utils/criteo/CriteoProvider.js";
import { memo, useState, useEffect, useMemo } from "react";
import { useBrowseContext } from "../../../Chrome/BrowseContext/hook.js";
import { useAuth } from "../../../../hooks/auth/useAuth/index.js";
import { ProductTileCarouselUI } from "./ProductTileCarouselUI.js";
import { useProductData, calculateInitialDisplayCount } from "./utils.js";
function ProductTileCarouselClientComponent({
  bdWHNumber,
  containerSx = {},
  analytics = {},
  itemNumbers,
  locale,
  variant,
  inventoryAware,
  showReviews,
  showActionButton,
  testId,
  isHorizontal,
  criteoDataSourceAttr,
  maxSlides,
  titleProps,
  navigationButtonBottomOffset = "80%",
  disableBottomControls,
  productTileMaxLineNumber,
  minProductTileImageWidth,
  maxProductTileImageWidth,
  hideReviewStarValue,
  maxProductTileImageHeight,
  productTileSx,
  productTileContainerSx,
  sx,
  peekAdjacent,
  showSlideNumber,
  wrapAround,
  ariaLabel,
  productTileNumberSeparator,
  slideGapSizes = {},
  navigationButtonsBottomAlign,
  navigationButtonsMobileDisplay,
  displayMultipleTiles = false,
  pageType,
  maxItemsPerSlide,
  componentType,
  randomizeItems,
  isProductDetailsPage,
  dataPrivate,
  maxSlidesBySize,
  product_tile_data_source,
  cookieContext,
  itemCuration,
  isCriteo
}) {
  const { productTileConfigData } = useProductTileConfig();
  const { concurrency } = useCriteo();
  const [isUserLoggedIn, setIsUserLoggedIn] = useState(
    false
  );
  const { isUserSignedIn, isLoading: isAuthUtilsLoading } = useAuth();
  useEffect(() => {
    if (!isAuthUtilsLoading) {
      isUserSignedIn().then((result) => {
        setIsUserLoggedIn(result);
      });
    }
  }, [isAuthUtilsLoading, isUserSignedIn]);
  const initialDisplayCount = calculateInitialDisplayCount(
    displayMultipleTiles,
    maxItemsPerSlide,
    maxSlides
  );
  const {
    isLoadingPopulatedProductData,
    populatedProductData,
    populatedProductDataError
  } = useProductData({
    concurrency,
    inventoryAware,
    itemNumbers,
    locale,
    productTileConfigData,
    bdWHNumber,
    initialDisplayCount,
    product_tile_data_source,
    isProductDetailsPage,
    cookieContext,
    isUserLoggedIn,
    itemCuration
  });
  return /* @__PURE__ */ jsx(
    ProductTileCarouselUI,
    {
      analytics,
      ariaLabel,
      componentType,
      containerSx,
      criteoDataSourceAttr,
      dataPrivate,
      disableBottomControls,
      displayMultipleTiles,
      hideReviewStarValue: isProductDetailsPage || hideReviewStarValue,
      inventoryAware,
      isHorizontal,
      isLoadingProductData: isLoadingPopulatedProductData,
      isProductDetailsPage,
      itemNumbers,
      locale,
      maxItemsPerSlide,
      maxProductTileImageHeight,
      maxProductTileImageWidth,
      maxSlides,
      maxSlidesBySize,
      minProductTileImageWidth,
      navigationButtonBottomOffset,
      navigationButtonsBottomAlign,
      navigationButtonsMobileDisplay,
      pageType,
      peekAdjacent,
      productData: populatedProductData,
      productDataLoadingError: populatedProductDataError,
      productTileContainerSx,
      productTileMaxLineNumber,
      productTileNumberSeparator,
      productTileSx,
      product_tile_data_source,
      randomizeItems,
      showActionButton,
      showReviews,
      showSlideNumber,
      slideGapSizes,
      sx,
      testId,
      titleProps,
      variant,
      wrapAround,
      isCriteo
    }
  );
}
const MemoizedProductTileCarouselClient = memo(
  ProductTileCarouselClientComponent
);
function ProductTileCarouselClient(props) {
  const { bdWarehouseNumber, wcMember, warehouse, bdDeliveryLocation } = useBrowseContext();
  const bdWarehouseNumberToUse = !props.bdWHNumber && isBD() ? bdWarehouseNumber == null ? void 0 : bdWarehouseNumber.value : props.bdWHNumber;
  const warehouseToUse = props.inventoryAware ? warehouse : void 0;
  const cookieContext = useMemo(() => {
    return {
      bdDeliveryLocation,
      wcMember,
      warehouse: warehouseToUse
    };
  }, [bdDeliveryLocation, wcMember, warehouseToUse]);
  return /* @__PURE__ */ jsx(
    MemoizedProductTileCarouselClient,
    {
      bdWHNumber: bdWarehouseNumberToUse,
      cookieContext,
      ...props
    }
  );
}
export {
  ProductTileCarouselClient,
  ProductTileCarouselClientComponent
};
